module.exports = {
	"id": "MG",
	"name": "Madagascar",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.00608,
			"6": 0.00608,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.0304,
			"12": 0.00912,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.00304,
			"17": 0.02736,
			"18": 0.00608,
			"19": null,
			"20": 0.00608,
			"21": null,
			"22": 0.00304,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.00912,
			"27": 0.00912,
			"28": 0.01216,
			"29": 0.02128,
			"30": 0.00912,
			"31": 0.0152,
			"32": 0.00608,
			"33": 0.01216,
			"34": 0.00608,
			"35": 0.00608,
			"36": 0.00608,
			"37": 0.00608,
			"38": 0.02736,
			"39": 0.0152,
			"40": 0.03344,
			"41": 0.00912,
			"42": 0.01216,
			"43": 0.08816,
			"44": 0.02432,
			"45": 0.05168,
			"46": 0.0152,
			"47": 0.20976,
			"48": 0.08208,
			"49": 1.16736,
			"50": 0.11248,
			"51": 0.228,
			"52": 0.18544,
			"53": 8.60624,
			"54": 2.43504,
			"55": 0.02736,
			"56": 0.00912,
			"57": null
		},
		"firefox": {
			"2": 0.0152,
			"3": 0.17328,
			"4": 0.0152,
			"5": 0.00608,
			"6": 0.00912,
			"7": null,
			"8": null,
			"9": 0.00304,
			"10": 0.01216,
			"11": 0.00608,
			"12": 0.02736,
			"13": 0.00608,
			"14": 0.0152,
			"15": 0.02128,
			"16": 0.0608,
			"17": 0.0152,
			"18": 0.01824,
			"19": 0.02736,
			"20": 0.02736,
			"21": 0.01824,
			"22": 0.0304,
			"23": 0.02432,
			"24": 0.01216,
			"25": 0.0152,
			"26": 0.01824,
			"27": 0.076,
			"28": 0.03344,
			"29": 0.0304,
			"30": 0.10032,
			"31": 0.13072,
			"32": 0.09424,
			"33": 0.0608,
			"34": 0.04256,
			"35": 0.11248,
			"36": 0.0608,
			"37": 0.14896,
			"38": 0.16416,
			"39": 0.12768,
			"40": 0.17936,
			"41": 0.13072,
			"42": 0.15504,
			"43": 0.684,
			"44": 0.16416,
			"45": 0.20064,
			"46": 0.13072,
			"47": 1.00016,
			"48": 0.72352,
			"49": 7.14096,
			"50": 0.15808,
			"51": 0.03344,
			"52": 0.00304,
			"3.5": 0.00608,
			"3.6": 0.02736
		},
		"opera": {
			"9": null,
			"11": 0.00912,
			"12": 0.00304,
			"15": 0.00304,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.01216,
			"21": 0.00304,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.02128,
			"30": 0.00608,
			"31": 0.00608,
			"32": null,
			"33": 0.00912,
			"34": 0.00912,
			"35": 0.02432,
			"36": 0.08816,
			"37": 0.05472,
			"38": 0.01824,
			"39": 0.02432,
			"40": 0.6384,
			"41": 0.0912,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.0456,
			"10.5": null,
			"10.6": null,
			"11.1": 0.00608,
			"11.5": null,
			"11.6": 0.00912,
			"12.1": 0.02736
		},
		"safari": {
			"0": null,
			"4": 0.00608,
			"5": 0.00608,
			"6": 0.00304,
			"7": 0.00608,
			"8": 0.08816,
			"9": 0.0608,
			"10": 0.27664,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03344,
			"6.1": 0.00608,
			"7.1": null,
			"9.1": 0.12464
		},
		"ios_saf": {
			"8": 0,
			"10": 0.480610392173,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0129518939425,
			"8.1-8.4": 0.0239280752498,
			"9.0-9.2": 0.0114152285595,
			"9.3": 0.174155410075
		},
		"android": {
			"3": 0,
			"4": 0.0960530594315,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0120066324289,
			"4.1": 0.346477107235,
			"4.2-4.3": 0.866192768088,
			"4.4": 1.98624005039,
			"4.4.3-4.4.4": 2.00339238243
		},
		"ie": {
			"6": 0.00659351351351,
			"7": 0.0395610810811,
			"8": 0.240663243243,
			"9": 0.0890124324324,
			"10": 0.0758254054054,
			"11": 0.524184324324,
			"5.5": null
		},
		"op_mob": {
			"0": 3.09343558506,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0859287662516
		},
		"edge": {
			"12": 0.04864,
			"13": 0.10032,
			"14": 0.09424
		},
		"ie_mob": {
			"10": 0.097454,
			"11": 0.396777
		},
		"bb": {
			"7": 0.07135025,
			"10": null
		},
		"samsung": {
			"0": 0.466387
		},
		"and_uc": {
			"0": 9.292935
		},
		"op_mini": {
			"0": 41.6773196487
		},
		"and_chr": {
			"0": 5.174688
		},
		"and_ff": {
			"0": 0.577763
		}
	},
	"total": 95.93994125
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MG.json
 ** module id = 586
 ** module chunks = 0
 **/